import React from "react";
import { includes } from "lodash";
import { Tag } from "primereact/tag";
import { useTranslation } from "react-i18next";

const OrderDamageCaseActionBadge = (props: any) => {
    const { type } = props;
    const { t } = useTranslation();

    if (!type) {
        return null;
    }

    // Danger severity for missing items
    if (includes(['missing-etr', 'missing-supplier-confirmation', 'missing-cmr', 'missing-photos', 'missing-damage-report'], type)) {
        return <Tag value={t(type)} severity="danger" />;
    }

    // Warning severity for pending items
    if (includes(['ic-pending', 'calculation-pending', 'invoice-pending'], type)) {
        return <Tag value={t(type)} severity="warning" />;
    }

    // Info severity for update items
    if (includes(['update-responsibility'], type)) {
        return <Tag value={t("missing supplier confirmation")} severity="info" />;
    }

    // Info severity for update items
    if (includes(['updated-calculation'], type)) {
        return <Tag value={t("updated calculation")} severity="warning" />;
    }

    // Default
    return <Tag value={t(type)} severity="info" />;
};

export default OrderDamageCaseActionBadge;

